import { createContext } from 'react';
import { TrackingScreen, TrackingSubscreen } from '../../app/utils/tracking/types';
export const FeedbackBtnClickTrackerContext = /*#__PURE__*/createContext({
  screen: TrackingScreen.PRODUCT_UPDATES,
  subscreen: TrackingSubscreen.ALL,
  origin: 'table',
  rolloutState: null,
  untranslatedPUTitle: ''
});
export const MeetingScheduleLinkClickTrackerContext = /*#__PURE__*/createContext({
  screen: TrackingScreen.PRODUCT_UPDATES,
  subscreen: TrackingSubscreen.ALL,
  origin: 'table'
});